module.exports = __webpack_public_path__ + "p2_img2.jpg?6fb31d69766058de4232bff114436070";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p2/p2_img2.jpg
// module id = 115
// module chunks = 0